var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFocusedArrowRightBracket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.222229,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#0073FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6616 24.4393C30.0758 25.0251 30.0758 25.9749 30.6616 26.5607L40.1009 36L30.6616 45.4393C30.0758 46.0251 30.0758 46.9749 30.6616 47.5607C31.2474 48.1464 32.1971 48.1464 32.7829 47.5607L43.2829 37.0607C43.8687 36.4749 43.8687 35.5251 43.2829 34.9393L32.7829 24.4393C32.1971 23.8536 31.2474 23.8536 30.6616 24.4393Z",
    fill: "#F6FBFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusedArrowRightBracket);
export default __webpack_public_path__ + "static/media/focused_arrow_right_bracket.40a7fc0ea372bbac8dacf269e5f78469.svg";
export { ForwardRef as ReactComponent };